export default __webpack_public_path__ + "static/media/icon-help.f6c53118.svg";